export const devContacts = [
  {
    name: 'Тимур Кармеев',
    nickname: '@ozzzpo',
    tg: 'https://t.me/ozzzpo',
    showAsSupport: true,
  },
  {
    name: 'Олег Хаметшин',
    nickname: '@warnoffline',
    tg: 'https://t.me/warnoffline',
    showAsSupport: true,
  },
  {
    name: 'Дмитрий Ивахненко',
    nickname: '@ivaaahn',
    tg: 'https://t.me/ivaaahn',
    showAsSupport: false,
  },
  {
    name: 'Григорий Китаев',
    nickname: '@g_kitaev',
    tg: 'https://t.me/g_kitaev',
    showAsSupport: false,
  },
];
